import { DescribeProperty } from '../../common';

export class SavedViewBcfUploadUrlResponse {
  @DescribeProperty({
    description: 'The storage file ID to attach to the saved view as `bcfFileId`',
    example: '123e4567-e89b-12d3-a456-426614174000',
    type: 'string',
    format: 'uuid',
  })
  fileId: string;

  @DescribeProperty({
    description: 'Short-lived presigned S3 URL accepting a PUT with the BCF viewpoint JSON',
    type: 'string',
  })
  uploadUrl: string;
}
